'use client';

import React from 'react';
import Link from 'next/link';
// import { VS_CODE_EXTENSION_LINK } from '@/utils/links';
import Image from 'next/image';

export default function Header() {
  // const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className='bg-[#F8F5FF] py-6'>
      <div className='max-w-6xl mx-auto px-6 sm:px-8'>
        <div className='flex justify-between items-center'>
          <Link href='/' className='inline-flex items-center gap-2'>
            <div className='flex items-center gap-2'>
              <Image
                src='/logo-1.png'
                alt='Takeoff Logo'
                width={60}
                height={60}
              />
              <span className='block text-[#1A1A1A] font-bold text-xl'>
                Takeoff
              </span>
            </div>
          </Link>

          <div className='flex justify-end'>
            <Link href='/pricing'>
              <button className='btn-secondary text-sm px-4 py-2'>
                Pricing 💫
              </button>
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
